<template>
  <div
    :class="$b({ isLinked, linkToLenses, linkToStrap })"
    @click="() => $emit('click')"
  >
    <VisionIcon
      v-if="isLinked"
      :class="$b('icon')"
      icon="unlink"
      colour="purple"
      size="x-small"
    />
    <VisionIcon
      v-else
      icon="link"
      colour="purple"
      size="x-small"
      :class="$b('icon')"
    />
    <VisionLink
      is-button
      line-link
      theme="gradient"
      :mono-font="true"
      :class="$b('link-button')"
    >
      <span v-if="isLinked">
        {{ $tr('Unlink') }}
      </span>
      <span v-else>
        <slot />
      </span>
    </VisionLink>
  </div>
</template>

<script>
export default {
  name: 'PartLinkButton',
  props: {
    isLinked: { type: Boolean, default: false },
    linkToLenses: { type: Boolean, default: false },
    linkToStrap: { type: Boolean, default: false },
  },
  emits: ['click'],
}
</script>

<style lang="postcss">
.PartLinkButton {
  @apply flex flex-row items-center gap-1
    relative
    cursor-pointer;
  -webkit-tap-highlight-color: transparent;
}

.PartLinkButton--link-to-lenses.PartLinkButton--is-linked,
.PartLinkButton--link-to-strap.PartLinkButton--is-linked {
  @apply opacity-0 md:opacity-100;
}

.PartLinkButton__link-button {
  @apply text-tiny whitespace-nowrap;
}

.PartLinkButton__icon {
  --icon-fill: theme('colors.purple') !important;
}
</style>
